import { FC } from 'react'
import { ModalSectionProps, RotaPatternModalType } from '../utils'
import { NeedsAssignedSection, SkillsRequiredSection } from '../sections'
import { VISIT } from 'screens/Rostering/constants'

export const SkillsTagsStep: FC<
  ModalSectionProps & { type?: RotaPatternModalType }
> = ({ type, formData }) => {
  return (
    <>
      {type === VISIT && <NeedsAssignedSection formData={formData} />}
      <SkillsRequiredSection type={type} formData={formData} />
    </>
  )
}
